import $ from "jquery";
import {isMobile} from "Core/screenSizes";

const wrapNavColumn = (html) => {
    return '<div class="nav-list-dropdown__column">' + html + '</div>';
}
const wrapNavLine = (wrapperClass, text, link) => {
    return `<div class="${wrapperClass}">
                <a href="${link}">${text}</a>
            </div>`;
};
const addColumn = (columnHtml, target) => {
    target.append(wrapNavColumn(columnHtml));
};

export const navLineWidth = () => {
    const navPadding = isMobile() ? 0 : 10;
    const columnItemsLimit = 10;
    const navLineParent = $('.wrapper__header');
    const navList = $('.nav-list');
    const navMenu = $('.nav-line-list-dropdown');
    let navListWidth = window.outerWidth > window.innerWidth ? window.innerWidth : window.outerWidth;
    let columnItemsCount = 0;
    let isListVisible = true;
    let columnHtml = '';
    let isShowDropDown = false;

    navListWidth -= $('.nav-more.dropdown').width();

    navLineParent.find('.nav-list .nav-list__item').remove();
    navMenu.find('.nav-list-dropdown__column').remove();

    const listMobile = $('.nav-line-mobile').find('.nav-mobile__list-inner');
    listMobile.find('.nav-mobile__item').remove();

    const elementName = 'nav-list--hidden';

    navLineParent.find(`.${elementName} .nav-list__item`).each((i, hiddenNavItemLink) => {
        const hiddenNavItem = $(hiddenNavItemLink);
        const hiddenNavItemPaddingLeft = parseInt(hiddenNavItem.css("padding-left"));
        const hiddenNavItemPaddingRight = parseInt(hiddenNavItem.css("padding-right"));
        const navElementWidth = (hiddenNavItem.width() + hiddenNavItemPaddingLeft + hiddenNavItemPaddingRight + navPadding);

        if (isListVisible && navElementWidth < navListWidth) {
            hiddenNavItem.clone().appendTo(navList);
            navListWidth -= navElementWidth;

            return;
        }

        isShowDropDown = true;

        isListVisible = false;

        if (isMobile()) {
            listMobile.append(wrapNavLine(
                'nav-mobile__item',
                hiddenNavItem.find('.nav-list__item-link').html(),
                hiddenNavItem.find('.nav-list__item-link').attr('href')
            ));

            return;
        }

        columnHtml = columnHtml + wrapNavLine(
            'nav-list-dropdown__column-item',
            hiddenNavItem.find('.nav-list__item-link').html(),
            hiddenNavItem.find('.nav-list__item-link').attr('href')
        );

        columnItemsCount++;

        if (columnItemsCount === columnItemsLimit) {
            addColumn(columnHtml, navMenu);
            columnItemsCount = 0;
            columnHtml = '';
        }
    });

    if (columnItemsCount > 0) {
        addColumn(columnHtml, navMenu);
    }

    if (isShowDropDown) {
        $('.nav-more.dropdown').show();
    } else {
        $('.nav-more.dropdown').hide();
    }
};
